"use strict";

export default angular.module("contartemx.bancos.reexpresiones", [
	"contartemx",
	"ngTable",
	"ui.router",
	"ui.bootstrap",
	"datePicker",
	"tableTools",
	"loader"
])

.controller("ReexpresionesCtrl", function ($scope, $state, mostrarNotificacion, $stateParams, dateTools, callToWebService, NgTableParams, $filter, $http, $uibModal, ServicioBusqueda) {

    $scope.selectedOpt = 0;
    $scope.reexpresionesActivas = true;
    $scope.estadoReexp = "Activas";
    $scope.noTieneMovimientos = false;
    $scope.llamadoInicial = 0;

    $scope.busqueda = {};
    $scope.busqueda.nombreCuenta = ServicioBusqueda.BancosReexpresiones.get("NombreCuenta");
    $scope.busqueda.fDate = ServicioBusqueda.BancosReexpresiones.get("FechaInicio");
    $scope.busqueda.tDate = ServicioBusqueda.BancosReexpresiones.get("FechaFin");

    $scope.fDate = dateTools.getDateStringFromWCF(ServicioBusqueda.BancosReexpresiones.get("FechaInicio"));
    $scope.tDate = dateTools.getDateStringFromWCF(ServicioBusqueda.BancosReexpresiones.get("FechaFin"));

    $scope.fechaString = function (fecha) {
        return new Date(parseInt(fecha.substr(6)));
    };

    $scope.estadoReexpresion = function (i) {
        $scope.selectedOpt = i;
        switch (i) {
            case 0:
                $scope.estadoReexp = "Activas";
                ServicioBusqueda.BancosReexpresiones.set("EstaActivo", true);
                $scope.reexpresionesActivas = true;
                obtenerListadoReexpresiones();
                break;
            case 1:
                $scope.estadoReexp = "Canceladas";
                ServicioBusqueda.BancosReexpresiones.set("EstaActivo", false);
                obtenerListadoReexpresiones();
                break;
        }
    };

    $scope.estadoReexpresion(ServicioBusqueda.BancosReexpresiones.get("EstaActivo") ? 0 : 1);

    function obtenerListadoReexpresiones() {
        $scope.loading = true;
        callToWebService.postCall('ObtenerListadoReexpresiones', { opciones: ServicioBusqueda.BancosReexpresiones.get() },
        function sucess(data) {
            if (data.CodigoRespuesta == 200) {
                $scope.movimientos = data.Respuesta;
                if (angular.isArray($scope.movimientos)) {
                    $scope.noMoreResults = $scope.movimientos.length < ServicioBusqueda.BancosReexpresiones.get("CantidadRegistrosSolicitados")
                }
                $scope.noTieneMovimientos = $scope.movimientos.length == 0;
                $scope.loading = false;
            } else {
                $scope.loading = false;
                mostrarNotificacion.error(data.Mensaje);
                $scope.noTieneMovimientos = true;
            }

        },
        function error(data) {
            mostrarNotificacion.error(data.Mensaje);
            $scope.loading = false;
            $scope.noTieneMovimientos = true;
        });
    }

    $scope.tableParams = new NgTableParams({
        page: 1,
        total: 1,
        count: 15,
        counts: [],
        sorting: {
            Fecha: "asc"
        }
    });

    $scope.ganancia = function (i) {
        if (i == true) {
            return "Ganancia";
        } else {
            return "Pérdida";
        }
    };

    $scope.select = function (index) {
        $scope.selectedRow = index;
    };

    $scope.deselect = function () {
        $scope.selectedRow = -1;
    };

    $scope.mostrarCancelarReexp = function () {
        for (var x = 0 ; x < $scope.movimientos.length ; x++) {
            $(".popover--Cancel[Indice='" + x + "']").addClass("popover--hidden");
        }
        var indexPop = $scope.selectedRow;
        $(".popover--Cancel[Indice='" + $scope.selectedRow + "']").removeClass("popover--hidden");
        $("#context-menu").removeClass("open");
    };

    $scope.cambiarEstadoReexpresion = function (ClaveTransaccion, opc) {

        if (opc == 0) {
            var esActivo = false;
        } else {
            var esActivo = true;
        }

        callToWebService.postCall('CambiarEstadoDeTransaccion', { cveTransaccion: ClaveTransaccion, EstaActivo: esActivo },
            function sucess(data) {
                if (data.CodigoRespuesta == 200) {
                    mostrarNotificacion.info(data.Mensaje);
                    obtenerListadoReexpresiones();
                } else {
                    mostrarNotificacion.info(data.Mensaje);
                }

            },
            function error(data) {
                mostrarNotificacion.info(data.Mensaje);
            });
    };

    $scope.$watch('tableParams', function (params, paramsOld) {
        let _params = params._params;
        if (params != paramsOld && params && _params.sorting) {
            $scope.traspasos = $filter('orderBy')($scope.traspasos, params.orderBy());
        }
    }, true);

    $scope.onFromDateSelect = function (fromDateString) {
        $scope.busqueda.fDate = $scope.Movil ? dateTools.getTimeForWCF(fromDateString, 'YYYY-MM-DD') : dateTools.getTimeForWCF(fromDateString, 'DD/MM/YY');
        $scope.fDate = fromDateString;
    }

    $scope.onToDateSelect = function (toDateString) {
        $scope.busqueda.tDate = $scope.Movil ? dateTools.getTimeForWCF(toDateString, 'YYYY-MM-DD') : dateTools.getTimeForWCF(toDateString, 'DD/MM/YY');
        $scope.tDate = toDateString;
    }

    $scope.addSearchCriteria = function () {

        var nombreCuenta = $scope.busqueda.nombreCuenta;
        var fDate = $scope.busqueda.fDate;
        var tDate = $scope.busqueda.tDate;

        if ($scope.fDate && fDate && $scope.tDate && tDate) {
            ServicioBusqueda.BancosReexpresiones.set({
                FechaInicio: fDate,
                FechaFin: tDate
            });
        } else {
            ServicioBusqueda.BancosReexpresiones.unset("FechaInicio");
            ServicioBusqueda.BancosReexpresiones.unset("FechaFin");
        }

        if (angular.isString(nombreCuenta) && nombreCuenta.length > 0) {
            ServicioBusqueda.BancosReexpresiones.set("NombreCuenta", nombreCuenta);
        } else {
            ServicioBusqueda.BancosReexpresiones.unset("NombreCuenta");
        }

        obtenerListadoReexpresiones();
    };

    $scope.eliminarFiltro = function (opciones) {
        if (angular.isObject(opciones)) {
            var actualizarLista = true;

            switch (opciones.filtro) {
                case 'NombreCuenta':
                    $scope.busqueda.nombreCuenta = null;
                    break;
                case 'Fecha':
                    $scope.fDate = null;
                    $scope.tDate = null;
                    ServicioBusqueda.BancosReexpresiones.unset("FechaInicio");
                    ServicioBusqueda.BancosReexpresiones.unset("FechaFin");
                    break;
                default:
                    actualizarLista = false;
                    break;
            }

            if (actualizarLista) {
                obtenerListadoReexpresiones();
            }

        }
    }

    $scope.removeSearchCriteria = function () {
        $scope.busqueda = {};
        $scope.fDate = null;
        $scope.tDate = null;
        ServicioBusqueda.BancosReexpresiones.reset();
        $scope.estadoReexpresion(ServicioBusqueda.BancosReexpresiones.get('EstaActivo') ? 0 : 1);
    };

    $scope.showMore = function () {
        ServicioBusqueda.BancosReexpresiones.set("CantidadRegistrosSolicitados", ServicioBusqueda.BancosReexpresiones.get("CantidadRegistrosSolicitados") + 15);
        obtenerListadoReexpresiones();
    };

});
